/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CodeStub } from './CodeStub'
import {ReferenceRange} from "./ReferenceRange"

export class Measure {
  /**
   * We delete min and max from the json and create a referenceRanges from it
   * Since this is a shallow copy, deletion of min and max will have no effect on the original json since it's the top level fields
   *
   * @param json
   */
  constructor(json: JSON | any) {
    const measureValue = {...json}

    if (!!measureValue?.min || !!measureValue?.max) {
      measureValue.referenceRanges = [
        new ReferenceRange({
          low: measureValue.min,
          high: measureValue.max
        })
      ]
      delete measureValue?.min
      delete measureValue?.max
    }

    Object.assign(this as Measure, measureValue)
  }

  value?: number
  ref?: number
  severity?: number
  severityCode?: string
  evolution?: number
  unit?: string
  sign?: string
  unitCodes?: Array<CodeStub>
  comment?: string
  comparator?: string
  /**
   * Reference range for the measure
   */
  referenceRanges?: Array<ReferenceRange>
}
